import React from 'react';
import AboutUs from '../components/AboutUs';

const AboutPage = () => {
    return (
        <div className="about-page reveal-fade">
            <AboutUs />
        </div>
    );
};

export default AboutPage;
